export enum BankOperationActionsMode {
  QuickReconcile,
  CreateTransfer,
}
